

const Item = (props) => {

    const handleClick = (ev) => {
        if(typeof props.onClick === "function"){
            props.onClick()
        }
    }

    return (
        <div className="stat-module" style={props.styles}>
            <div className="icon" style={{background: props.background, color: '#fff'}} onClick={handleClick}>
                {props.icon}
            </div>
            <div className="info">
                {props.label}
                <div className="stat-values">
                    <div className="items">{props.items}</div>
                    <div className="percentage">({props.percent}%)</div>
                </div>
            </div>
        </div>
    )
}

export default Item;